//--
import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';
//#region comment metod

const UpdateShippingCompanyRedirectManagement = (data?: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateShippingCompanyRedirectManagement,
        method: RequestType.POST,
        data,
    });

const CargoPrioritizationCommand = {
    UpdateShippingCompanyRedirectManagement,
};

export default CargoPrioritizationCommand;
